module.exports = __webpack_public_path__ + "media/images/countryrect/th-9074292fbde852448f2095479a61727e.svg";